export default "__VITE_ASSET__BQIx2yy3__"